/**
 * Checks if the given element is a large container type.
 *
 * @param {ApiElement} element - The element to check.
 * @returns {boolean} True if the element is a large container, otherwise false.
 */
export function isContainerLarge(element) {
  return (
    element.type === 'CONTAINER_LARGE_A' ||
    element.type === 'CONTAINER_LARGE_B' ||
    element.type === 'CONTAINER_LARGE_C'
  );
}

export const RendererTypes = {
  CONTENT_HUB_HERO: 'CONTENT_HUB_HERO',
};
